import {
  TransactableSourceType,
  TransactableTypeDisplay,
} from '@monetize/types/app';
import { HeaderLabel } from './TransactionApplicationTableHeader';

interface RefundApplicationTableHeaderProps {
  sourceType: TransactableSourceType;
}

/**
 * Header variant used by the refund flow. Mirrors
 * {@link TransactionApplicationTableHeader} but drops the Amount Due and Status
 * columns and relabels "Applied from other Payments & Credits" to "Paid amount".
 */
export const RefundApplicationTableHeader = ({
  sourceType,
}: RefundApplicationTableHeaderProps) => {
  const entityName = TransactableTypeDisplay[sourceType];
  return (
    <>
      <HeaderLabel alignment="left" label="Invoice" colSpan={2} />
      <HeaderLabel alignment="right" label="Amount" />
      <HeaderLabel alignment="center" label="Paid amount" />
      <HeaderLabel
        alignment="center"
        label={`Applied from this ${entityName}`}
      />
    </>
  );
};
